import React from 'react';

interface PaginationBarProps {
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  onPageChange: (page: number) => void;
}

const PaginationBar: React.FC<PaginationBarProps> = ({ pagination, loading, onPageChange }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 flex items-center justify-between p-4 bg-black/20 backdrop-blur-md border-t border-white/10">
      <div className="text-sm text-white/60 whitespace-nowrap">
        共 {pagination.total} 条，第 {pagination.page} / {pagination.totalPages} 页
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(pagination.page - 1)}
          disabled={loading || pagination.page <= 1}
          className="w-10 h-10 flex items-center justify-center bg-white/10 text-white border border-white/20 rounded-lg hover:bg-white/20 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={() => onPageChange(pagination.page + 1)}
          disabled={loading || pagination.page >= pagination.totalPages}
          className="w-10 h-10 flex items-center justify-center bg-white/10 text-white border border-white/20 rounded-lg hover:bg-white/20 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
